import http from "@/http/aisea/axios";
const resource = "/enterprises/workflows";

const enterpriseWorkflowRepository = {
  /**
   * APIで法人のWorkflow一覧を取得する
   * @returns {Promise<Object>}
   * @property {boolean} status - APIのリクエストが成功したかどうか
   * @property {number} code - ステータスコード
   * @property {EnterpriseWorkflow[]} data - データ
   * @property {string} message - メッセージ
   *  @throws {Error}
   */
  index() {
    return http.get(`${resource}`);
  },
};

export default enterpriseWorkflowRepository;
